<template>
  <div>
    <VTextField
      v-model="data.name[selectedLang]"
      :label="`${$t('forms.labels.name')}`"
      :rules="{ required: selectedLang === teamMainLang, min: 1, max: 200 }"
      outlined
      @input="updateData"
    />
    <VAutocomplete
      v-model="data.networkTypes"
      :label="$t('forms.labels.networkTypes')"
      :items="networkTypes"
      multiple
      :loading="loading"
      :rules="{ required: true }"
      outlined
      data-cy="addNetworkTypes"
      @input="updateData"
    />
  </div>
</template>

<script>
import { LOCALES } from '@/locales/i18n';
import { mapGetters } from 'vuex';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';

export default {
    components: {
        VTextField,
        VAutocomplete,
    },
    props: {
        treatmentControl: {
            type: Object,
            default: () => ({}),
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        networkTypes: [],
        loading: false,
        langs: LOCALES,
        data: {
            name: {},
            networkTypes: [],
        },
    }),
    computed: {
        ...mapGetters([
            'userLang',
            'selectedLang',
            'teamMainLang',
        ]),

    },
    async created() {
        if (this.isEdition) {
            this.data = this.treatmentControl;
            this.data.networkTypes = this.treatmentControl.networkTypes.map(({ id }) => id);
        }

        await this.getNetworkTypes();
    },
    methods: {
        async getNetworkTypes() {
            this.loading = true;
            const { data } = await this.$rq.getNetworkTypes();
            this.networkTypes = data.networkTypes.map(({ name, id }) => ({ id, name: name[this.selectedLang || this.teamMainLang] }));
            this.loading = false;
        },
        updateData() {
            this.$emit('sendData', this.data);
        },
    },
};
</script>
